import React, {useEffect, useRef, useState} from "react";

import Button from 'components/Button'
import {FixedRating} from "components/Rating";
import {CarouselHotels} from "components/Carousel";
import {SearchBarHotels} from "components/SearchBarHotels";
import {useNavigate, Navigate} from "react-router-dom";
import {FiChevronDown, FiChevronUp, FiMapPin} from "react-icons/fi";

import { Container } from 'react-bootstrap'
import {
    HotelInformation,
    DivAbout,
    Paragraph,
    BoxRoom,
    Rooms,
    RoomContent,
    Rules,
} from "./styles";

import {AiOutlineCheckCircle} from "react-icons/ai";
import {IoPerson} from "react-icons/io5";
import {ModalApp} from "components/Modal";
import Map from "components/Map";
import {formatCurrency} from "../../utils/functions";
import {LoaderSmall} from "../../components/Loader";
import {useApp} from "../../contexts/AppContext";
import {changeSelectedRoomHotelAction} from "../../contexts/reducers/hotels/actions";

export function Hotel() {
    const [loading, setLoading] = useState(false)
    const [info, setInfo] = useState(true)
    const [open, setOpen] = useState(false)
    const [infoRoom, setInfoRoom] = useState(null)

    const [checkedRoom, setCheckedRoom] = useState()

    const { hotelState, hotelDispatch } = useApp()
    const { hotel, offersHotel, travellers } = hotelState

    const scroll = useRef(null)

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    },[])

    const navigation = useNavigate()

    const handleModal = () => {
        setOpen(!open);
    };

    function handleContinue() {
        navigation('/loja/hotel-travellers')
    }

    function handleShowRooms(index) {
        setInfoRoom(index)
    }

    const coords = {
        lat: hotel.address && JSON.parse(hotel?.address?.latitude),
        lng: hotel.address && JSON.parse(hotel?.address?.longitude),
    }

    const selected = {
        name: hotel?.name,
        show: true
    }

    function handleInfo() {
        setInfo(!info)
    }

    const handleReserve = (room, index) => {
        hotelDispatch(changeSelectedRoomHotelAction(room))
        setCheckedRoom(index)
    }

    const Room = () => {

        const totalPeople = travellers?.length;

        const Icon = () => {
            let icons = [];
            for (let i = 1; i <= totalPeople; i++) {
                icons.push(<IoPerson key={i}/>)
            }
            return icons
        }

        return (
            <Rooms>
                { hotel.rooms.map((item, index) => {

                    const price = item?.amount.BRL
                    const points = item?.amount.WL

                    const externalProperties = JSON.parse(item?.externalProperties)

                    return (
                        <RoomContent key={index} className={`${checkedRoom === index && 'border-checked'}`}>
                            <p className="label">{item.name}</p>
                            <span className="price-icon">
                                Preço para <Icon/>
                            </span>

                            <div className="div-info">
                                { externalProperties["Refundable"] === "False"
                                    && <p className="info-1">Sem Rebolso</p> }

                                { externalProperties["Refundable"] === "True"
                                    && <p className="info-1">Com Rebolso</p> }

                                { item?.board?.description === "Breakfast"
                                    ? <p className="info-2"> Café da manhã incluso</p>
                                    : <p className="info-2"> Não incluso</p>
                                }
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="price">
                                        { offersHotel === "cash" && <p> { formatCurrency(price) }</p> }
                                        { offersHotel === "points" && <p> { parseFloat(points).toLocaleString() } <span>Pts</span> </p> }
                                        <p className="span">taxas inclusas</p>
                                    </div>
                                </div>
                                <div className="col">
                                    <Button width="146px" onClick={() => handleReserve(item, index)}>
                                        { checkedRoom === index ? 'Reservado' : 'Reservar' }
                                    </Button>
                                </div>
                            </div>

                            { infoRoom === index && (
                                <div className="divText">
                                    <p className="title">Sobre o quarto</p>
                                    <span className="paragraph">
                                       { item?.description ? item?.description : '-' }
                                    </span>
                                </div>
                            )}

                            { item.description &&
                                infoRoom === index  ?
                                <span onClick={() => setInfoRoom(null)} className="ver-mais">
                                        <span>Ver Menos <FiChevronUp/></span>
                                    </span>
                                :
                                <span onClick={() => handleShowRooms(index)} className="ver-mais">
                                        <span>Ver Mais <FiChevronDown/></span>
                                    </span>
                            }

                        </RoomContent>
                        )
                    }
                )}
            </Rooms>
        )
    }

    const executeScroll = () => {
        scroll.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }

    if (loading) return <LoaderSmall />

    if(!loading && !hotel.name) return <Navigate to="/loja/search-hotels-result" />

    return (
        <>
            <SearchBarHotels info={info} handleInfo={handleInfo}/>

            { hotel.name &&
                <>
                    <Container className="container-page px-4">
                        <HotelInformation>

                            <div className="hotel">
                                <h3>{hotel.name}</h3>
                                <FixedRating value={hotel.stars}/>
                            </div>

                            <span role="button" className="map" onClick={handleModal}>
                                <FiMapPin className="me-1 fs-6"/>
                                {hotel.address.street}, {hotel.address.number} - {hotel.address.state}, {hotel.address.city}
                            </span>

                            <ModalApp show={open} handleModal={handleModal} isMap={true}>
                                <Map params={coords} selected={selected} boxHotel="name"/>
                            </ModalApp>

                        </HotelInformation>

                        <CarouselHotels images={hotel.images}/>

                        <div className="mb-3" >
                            <Button type="button" onClick={executeScroll}>Ver disponibilidade</Button>
                        </div>


                        <DivAbout>
                            <p className="sobre-hotel">Sobre o Hotel</p>
                            <Paragraph>
                                {hotel?.description}
                            </Paragraph>
                            <p className="quarto mb-0">Quartos</p>
                            <Paragraph>Encontre a melhor acomodação neste hotel</Paragraph>
                        </DivAbout>
                    </Container>

                    <BoxRoom>
                        <nav className="px-4">
                            <div className="nav nav-tabs border-bottom-0 d-flex gap-1" id="nav-tab" role="tablist">

                                <button
                                    className="nav-link active button-tab"
                                    id={`room-1`}
                                    data-bs-toggle="tab"
                                    data-bs-target={`#nav-room-1`}
                                    type="button"
                                    role="tab"
                                    aria-controls={`nav-room-1`}
                                    aria-selected="true"
                                >
                                    Quarto <AiOutlineCheckCircle/>
                                </button>

                            </div>
                        </nav>
                        <div ref={scroll} style={{marginTop: "90px", position: "absolute"}}/>
                        <div className="tab-content" id="nav-tabContent" style={{maxHeight: "600px", overflow: "auto"}}>
                            <div

                                className={`tab-pane fade show active`}
                                id={`nav-room-1`}
                                role="tabpanel"
                                aria-labelledby={`nav-room-1-tab`}
                            >
                                <Room/>
                            </div>

                        </div>
                    </BoxRoom>

                    <Rules>
                        <p className="rule">Regras do Estabelecimento</p>
                        <div className="div-check">
                            <p>
                                Check-in
                                <span>
                                    {
                                        hotel?.rooms[0].checkIn.hour
                                        + ":" +
                                        hotel?.rooms[0].checkIn.minutes
                                    }
                                </span>
                            </p>
                            <p>
                                Check-in
                                <span>
                                    {
                                        hotel?.rooms[0]?.checkOut.hour
                                        + ":" +
                                        hotel?.rooms[0]?.checkOut.minutes
                                    }
                                </span>
                            </p>
                        </div>
                        {/*<p>Restrições de idade </p>*/}
                        {/*<p className="info">A idade mínima para Check-in é 18 anos</p>*/}
                        {/*<p>Cartões</p>*/}
                        {/*<p className="info">Mastercard e Visa</p>*/}
                        {/*<p>Festas</p>*/}
                        {/*<p className="info">Festas e eventos não são permitidos</p>*/}
                        {/*<p>Horário de Silêncio</p>*/}
                        {/*<p className="info">das 22:00 às 07:00</p>*/}
                        <div className="my-4">
                            <Button
                                onClick={handleContinue}
                                disabled={!hotelState.room.name}
                            >
                                CONTINUAR
                            </Button>
                        </div>
                    </Rules>
                </>
            }
        </>
    );
}
